import { Elements } from '@/components';
import featuresBackground from '@images/hero-bg.webp';

export const IchraSolution = () => {
    return (
        <section
            className="overflow-hidden bg-cover bg-center bg-no-repeat px-5 pt-20 pb-20 md:px-10 lg:px-[79px]"
            style={{ backgroundImage: `url(${featuresBackground})` }}
        >
            <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-center gap-10 md:items-start">
                <div className="flex flex-col items-center justify-center gap-2 mx-auto">
                    <Elements.Title title="ICHRA Solutions for All" type="h2" className="text-center text-gray-50" />
                    <Elements.Description
                        description="Our platform adapts to your specific business model, ensuring you maintain control while providing exceptional value to your clients."
                        type="medium"
                        className="max-w-[680px] text-center text-gray-50"
                    />
                </div>

                <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-6 md:grid-cols-1 lg:grid-cols-3 items-stretch justify-items-center lg:justify-items-stretch">
                    <Elements.IchraCard
                        title="Brokers"
                        description="Designed from the ground-up for brokers. Your BOR status is retained. Always. We're here to support your role, not threaten it."
                        points={[
                            'Retain 100% of commissions - no revenue sharing',
                            'Set your own fee structure - you control pricing',
                            'Leverage our included templates to pitch ICHRA to current clients',
                            'HIPAA compliant with end-to-end encryption',
                        ]}
                        buttonLabel="Book a Demo"
                    />
                    <Elements.IchraCard
                        title="Carriers"
                        description="White-labeled ICHRA platform built for carriers to promote ICHRA products under their own brand and customer experience."
                        points={[
                            'End-to-end ICHRA platform under your brand',
                            'Empower broker channels and drive enrollment',
                            'Reconcile individual enrollments and payments',
                            'HIPAA compliant with end-to-end encryption',
                        ]}
                        buttonLabel="Book a Demo"
                    />
                    <Elements.IchraCard
                        title="TPAs"
                        description="Launch a white-labeled ICHRA solution while supporting distribution channels. "
                        points={[
                            'Easily integrate with existing benefit systems',
                            'Maintain existing approaches to payments, COBRA and compliance',
                            'Brokers maintain AOR/BOR relationships',
                            'HIPAA compliant with end-to-end encryption',
                        ]}
                        buttonLabel="Book a Demo"
                    />
                </div>
            </div>
        </section>
    );
};
